import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { SubscriptionNewsfeedResolver } from './resolver/newsfeed-exhibitor.resolver';
import { RootNewsfeedResolver } from './resolver/newsfeed-root.resolver';
import { UserHistoryNewsfeedResolver } from './resolver/newsfeed-user-history.resolver';
import { NewsfeedService } from './service/data-access-newsfeed.service';

import { NewsfeedPageEffects } from './state/newsfeed-page/newsfeed-page.effects';
import { NewsfeedPageFacade } from './state/newsfeed-page/newsfeed-page.facade';
import * as fromNewsfeedPage from './state/newsfeed-page/newsfeed-page.reducer';
import { NewsfeedQuicklinksEffects } from './state/newsfeed-quicklinks/newsfeed-quicklinks.effects';
import { NewsfeedQuicklinksFacade } from './state/newsfeed-quicklinks/newsfeed-quicklinks.facade';
import * as fromNewsfeedQuicklinks from './state/newsfeed-quicklinks/newsfeed-quicklinks.reducer';
import { NewsfeedResultsEffects } from './state/newsfeed-results/newsfeed-results.effects';
import { NewsfeedResultsFacade } from './state/newsfeed-results/newsfeed-results.facade';
import * as fromNewsfeedResults from './state/newsfeed-results/newsfeed-results.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromNewsfeedResults.NEWSFEED_RESULTS_FEATURE_KEY,
      fromNewsfeedResults.newsfeedResultsReducer
    ),
    StoreModule.forFeature(fromNewsfeedPage.NEWSFEED_PAGE_FEATURE_KEY, fromNewsfeedPage.newsfeedPageReducer),
    StoreModule.forFeature(
      fromNewsfeedQuicklinks.NEWSFEED_QUICKLINKS_FEATURE_KEY,
      fromNewsfeedQuicklinks.newsfeedQuicklinksReducer
    ),
    EffectsModule.forFeature([NewsfeedPageEffects, NewsfeedResultsEffects, NewsfeedQuicklinksEffects]),
  ],
  providers: [
    NewsfeedPageFacade,
    NewsfeedResultsFacade,
    NewsfeedService,
    NewsfeedQuicklinksFacade,
    RootNewsfeedResolver,
    SubscriptionNewsfeedResolver,
    UserHistoryNewsfeedResolver,
  ],
})
export class Bau365DataAccessNewsfeedModule {}
